// Función para crear un matcher para filtrado
export const createMatcher = (targetNombre, targetId) => {
  const nombreNormalizado = targetNombre ? targetNombre.toString().trim().toLowerCase() : null;
  const idNormalizado = targetId != null ? targetId.toString() : null;

  if (!nombreNormalizado && !idNormalizado) return null;

  const matcher = (valor) => {
    if (valor === undefined || valor === null) return false;

    if (Array.isArray(valor)) {
      return valor.some((item) => matcher(item));
    }

    if (typeof valor === "object") {
      const posibles = [
        valor.IdPatologia,
        valor.idPatologia,
        valor.IdZonaSanitaria,
        valor.idZonaSanitaria,
        valor.Id,
        valor.id,
        valor.Nombre,
        valor.nombre,
        valor.NombrePatologia,
        valor.nombrePatologia,
        valor.NombreZona,
        valor.nombreZona,
        valor.Descripcion,
        valor.descripcion
      ];

      return posibles.some((item) => matcher(item));
    }

    const valorString = valor.toString().trim();
    if (idNormalizado && valorString === idNormalizado) return true;
    if (nombreNormalizado && valorString.toLowerCase() === nombreNormalizado) return true;

    return false;
  };

  return matcher;
};

// Funciones de filtrado por patología y zona
export const itemMatchesPatologia = (item, patologiaMatcher) => {
  if (!patologiaMatcher) return true;

  const candidatos = [
    item.IdPatologia,
    item.idPatologia,
    item.Patologia,
    item.patologia,
    item.NombrePatologia,
    item.nombrePatologia,
    item.Patologias,
    item.patologias,
    item.PatologiaNombre,
    item.patologiaNombre,
    item?.Patologia?.Nombre,
    item?.Patologia?.IdPatologia,
    item?.patologiaDetalle
  ].filter(
    (valor) =>
      valor !== undefined &&
      valor !== null &&
      !(Array.isArray(valor) && valor.length === 0)
  );

  if (candidatos.length === 0) return false;

  return candidatos.some((valor) => patologiaMatcher(valor));
};

export const itemMatchesZona = (item, zonaMatcher) => {
  if (!zonaMatcher) return true;

  const candidatos = [
    item.IdZonaSanitaria,
    item.idZonaSanitaria,
    item.Zona,
    item.zona,
    item.NombreZona,
    item.nombreZona,
    item.ZonaSanitaria,
    item.zonaSanitaria,
    item?.Zona?.Nombre,
    item?.Zona?.IdZonaSanitaria,
    item?.zonaDetalle
  ].filter(
    (valor) =>
      valor !== undefined &&
      valor !== null &&
      !(Array.isArray(valor) && valor.length === 0)
  );

  if (candidatos.length === 0) return false;

  return candidatos.some((valor) => zonaMatcher(valor));
};

// Funciones para procesar relaciones
export const relacionesToString = (rel) => {
  if (!rel) return "";
  if (Array.isArray(rel)) {
    return rel.map(r => r.idTipoRelacion ?? r.idTipoRelacion ?? r.idTipoRelacion ?? "").filter(Boolean).join(", ");
  }
  if (typeof rel === "object") return String(rel.idTipoRelacion ?? rel.idTipoRelacion ?? "");
  return String(rel);
};

export const convivienteStatus = (rel) => {
  if (!rel) return "No";
  const arr = Array.isArray(rel) ? rel : [rel];
  return arr.some(r => r.conviviente === true) ? "Sí" : "No";
};